import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import configureStore from "./configureStore";

import Home from "./containers/Home";
import SignIn from "./containers/SignIn";
import ChangePassword from "./containers/ChangePassword";
import NoMatch from "./components/NoMatch";

import "./scss/index.scss";

// Include the bootstrap js file with jquery.
require("bootstrap/dist/js/bootstrap.bundle.min");

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path="/sign-in/" component={SignIn} />
        <Route exact path="/change-password/" component={ChangePassword} />
        <Route exact path="/" component={Home} />
        <Route component={NoMatch} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
